import { render, staticRenderFns } from "./OCardHomeComp.vue?vue&type=template&id=a29070ca&"
import script from "./OCardHomeComp.vue?vue&type=script&lang=js&"
export * from "./OCardHomeComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports